import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import axios from 'axios';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "attendanceStudentDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      attendanceInfo: {},
      noDataMsg: CONFIG.NO_DATA_EXIST,
    };
  },

  methods: {
    getAttendanceDetail () {
      var request = {
        params: {
          id: this.$route.params.id
        }
      }
      axios.get("/studentAttendance/detail", request)
        .then(response => {
          this.attendanceInfo = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Attendance Student Detail API Error", error);
        });
    },

    showList() {
      this.$router.push({
        path: "/attendanceStudent/list"
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.getAttendanceDetail();
  },
};
